import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SearchIndexDocument } from '@jessie/commons';


@Component({
    selector: 'app-document-list',
    templateUrl: './document-list.component.html',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentListComponent {
  @Input()
  documents!: SearchIndexDocument[];

  @Output()
  editDocument = new EventEmitter<SearchIndexDocument>();

  constructor() {}

  edit(document: SearchIndexDocument) {
    this.editDocument.emit(document);
  }
}
